module.exports = __webpack_public_path__ + "img/EBSoftware3.46f3d2a2.png";